import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrequencyTranslationPipe } from '@client/app/modules/page-performance/pipes/frequency-translation.pipe';
import { PagePerformanceRunService } from '@client/app/modules/page-performance/run/page-performance.run';

export function init_app (pagePerformanceRunService: PagePerformanceRunService) {
    return () => pagePerformanceRunService.initializeApp();
}

@NgModule({
    declarations: [
        FrequencyTranslationPipe,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        FrequencyTranslationPipe,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [PagePerformanceRunService],
            multi: true,
        }],

})
export class PagePerformanceModule { }
